<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-about">
            <div class="footer-logo">
              <span class="logo-text">VASTI</span>
            </div>
            <p>{{ t.footer.companyDesc }}</p>
            <div class="social-links">
              <a href="#" class="social-link"><i class="icon-wechat"></i></a>
              <a href="#" class="social-link"><i class="icon-weibo"></i></a>
              <a href="#" class="social-link"><i class="icon-linkedin"></i></a>
            </div>
          </div>
          <!-- 联系方式已暂时注释
          <div class="footer-contact">
            <h4>{{ t.footer.contact }}</h4>
            <ul>
              <li>
                <i class="icon-location"></i>
                <span>{{ t.footer.address }}</span>
              </li>
              <li>
                <i class="icon-phone"></i>
                <span>{{ t.footer.phone }}</span>
              </li>
              <li>
                <i class="icon-email"></i>
                <span>{{ t.footer.email }}</span>
              </li>
            </ul>
          </div>
          -->
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
import { messages } from '../i18n/index.js'

export default {
  name: 'FooterSection',
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  computed: {
    t() {
      return messages[this.locale] || messages.en
    }
  }
}
</script>

<style scoped>
.footer {
  background: var(--color-text-heading);
  color: var(--color-surface);
}

.footer-main {
  padding: var(--space-3xl) 0 var(--space-2xl);
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: var(--space-3xl);
  align-items: start;
}

.footer-logo {
  margin-bottom: var(--space-md);
}

.footer-logo .logo-text {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-surface);
  display: block;
  letter-spacing: var(--letter-spacing-wide);
  line-height: var(--line-height-tight);
}

.footer-logo .logo-sub {
  font-size: var(--font-size-xs);
  color: var(--color-primary);
  letter-spacing: var(--letter-spacing-wider);
  font-weight: var(--font-weight-semibold);
}

.footer-about p {
  color: rgba(255, 255, 255, 0.72);
  line-height: var(--line-height-normal);
  margin-bottom: var(--space-md);
  font-size: var(--font-size-sm);
  max-width: 420px;
  letter-spacing: var(--letter-spacing-wide);
}

.social-links {
  display: flex;
  gap: var(--space-md);
}

.social-link {
  width: 42px;
  height: 42px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-base);
  border: 1px solid transparent;
}

.social-link:hover {
  background: var(--color-primary);
  border-color: var(--color-primary);
  transform: translateY(-3px);
}

.footer-contact h4 {
  font-size: var(--font-size-base);
  margin-bottom: var(--space-md);
  color: var(--color-surface);
  position: relative;
  padding-bottom: var(--space-sm);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--letter-spacing-wide);
}

.footer-contact h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 32px;
  height: 2px;
  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-light));
  border-radius: var(--radius-full);
}

.footer-contact ul {
  list-style: none;
}

.footer-contact li {
  display: flex;
  align-items: flex-start;
  gap: var(--space-sm);
  color: rgba(255, 255, 255, 0.72);
  font-size: var(--font-size-sm);
  margin-bottom: var(--space-sm);
  letter-spacing: var(--letter-spacing-wide);
}

.footer-contact i {
  width: 20px;
  height: 20px;
  background: var(--color-primary);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  margin-top: 2px;
}

@media (max-width: 768px) {
  .footer-main {
    padding: var(--space-2xl) 0 var(--space-lg);
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: var(--space-2xl);
  }

  .footer-about {
    text-align: center;
  }

  .footer-about p {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .social-links {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-main {
    padding: var(--space-xl) 0 var(--space-md);
  }

  .footer-logo .logo-text {
    font-size: var(--font-size-lg);
  }

  .footer-contact h4 {
    font-size: var(--font-size-sm);
  }

  .footer-contact li {
    font-size: var(--font-size-xs);
  }
}
</style>
